module.exports = __webpack_public_path__ + "img/upgrade.32cea54.webp";